<template>
  <div>
    <div class="menu-space" />
    <div class="container-menu topo no-print" ref="menuContainer">
      <header>
        <nav class="w-100">
          <div class="container container-menu-topo py-3">
            <div class="row d-flex align-items-center container-menu-topo-inner">
              <div class="col button-mobile" @click="toggleNavigation">
                <div class="navbar-toggle d-flex align-items-left flex-column-reverse">
                  <span class="sr-only">Toggle navigation</span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                </div>
              </div>
              <div class="col-4 list_mobile_hidden">
                <ul class="d-flex justify-content-between align-items-center m-0 lista-menu-topo">
                  <li>
                    <a target="_blank"
                      href="https://www.uolhost.uol.com.br/?utm_medium=afiliados.uol.com.br&utm_source=afiliados&utm_campaign=barra_uol&utm_content=link_fixo_uolhost&utm_term=afiliados-uolhost">UOL
                      HOST
                    </a>
                  </li>
                  <li>
                    <a target="_blank"
                      href="https://pagbank.com.br/?utm_medium=afiliados.uol.com.br&utm_source=afiliados&utm_campaign=barra_uol&utm_content=link_fixo_pagbank&utm_term=afiliados-pagbank">
                      PAGBANK
                    </a>
                  </li>
                  <li>
                    <a target="_blank"
                      href="https://www.portaleducacao.com.br/?utm_medium=afiliados.uol.com.br&utm_source=afiliados&utm_campaign=barra_uol&utm_content=link_fixo_cursos&utm_term=afiliados-cursos">
                      CURSOS
                    </a>
                  </li>
                  <li>
                    <a target="_blank"
                      href="http://produtos.uol.com.br/?cmpid=mais-produtos&utm_medium=afiliados.uol.com.br&utm_source=afiliados&utm_campaign=barra_uol&utm_content=link_fixo_mais_produtos&utm_term=afiliados-mais-produtos">
                      + PRODUTOS
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-6 col-lg d-flex align-items-center justify-content-start
                          justify-content-lg-center">
                <a class="logo-uol" target="_blank" :class="{disabled: $route.path == '/manutencao'}"
                  :href="changeLogoHref">
                  <img width="80" class="img-fluid list_mobile_hidden" src="@/assets/images/logo-compact.svg"
                    alt="UOL - Universo Online">
                  <img width="170" class="img-fluid logo_mobile" src="@/assets/images/logo-header.svg"
                    alt="UOL - Universo Online">
                </a>
              </div>
              <div class="col">
                <ul class="d-flex justify-content-between flex-row-reverse m-0 p-0 lista-menu-topo">
                  <li class="content-avatar">
                    <div id="profile-avatar"></div>
                  </li>
                  <li class="list_mobile_hidden">
                    <a target="_blank"
                      href="https://sac.uol.com.br/?utm_medium=afiliados.uol.com.br&utm_source=afiliados&utm_campaign=barra_uol&utm_content=link_fixo_sac&utm_term=afiliados-sac">
                      SAC
                    </a>
                  </li>
                  <li class="list_mobile_hidden"><i class="icon-mail"></i>&nbsp;
                    <a target="_blank"
                      href="https://email.uol.com.br/?utm_medium=afiliados.uol.com.br&utm_source=afiliados&utm_campaign=barra_uol&utm_content=link_fixo_email&utm_term=afiliados-email">
                      E-MAIL
                    </a>
                  </li>
                  <li class="list_mobile_hidden"><i class="icon-search"></i>&nbsp;
                    <a target="_blank"
                      href="https://busca.uol.com.br/?utm_medium=afiliados.uol.com.br&utm_source=afiliados&utm_campaign=barra_uol&utm_content=link_fixo_busca&utm_term=afiliados-busca">
                      BUSCA
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
    <div v-if="$route.path != '/manutencao'" :class="{ 'menu-right': showNavigation }"
      :style="{ 'padding-top': `${menuHeight + 10}px` }" class="side-menu menu-left" ref="sideMenu">
      <ul>
        <li :class="this.selectPage('/')" @click="toggleNavigation">
          <router-link :to="{ path: '/', query: queryObject }">
            Painel
          </router-link>
        </li>
        <li :class="this.selectPage('/campanhas')" @click="toggleNavigation">
          <router-link :to="{ path: '/campanhas', query: queryObject }">
            Campanhas
          </router-link>
        </li>
        <li :class="this.selectPage('/relatorios')" @click="toggleNavigation">
          <router-link :to="{ path: '/relatorios', query: queryObject }">
            Relatórios
          </router-link>
        </li>
        <li @click="toggleNavigation"><a :href="`/extrato.html${queryString}`">Extrato</a></li>
        <li @click="toggleNavigation"><a :href="`/sites.html${queryString}`">Sites</a> </li>
        <li :class="this.selectPage('/contato')" @click="toggleNavigation">
          <router-link :to="{ path: '/contato', query: queryObject }">
            Contato
          </router-link>
        </li>
        <li @click="toggleNavigation">
          <a :href="`/dados-de-recebimento.html${queryString}`">
            Dados de recebimento
          </a>
        </li>
        <li :class="this.selectPage('/social-media-insights')" @click="toggleNavigation" v-if="isInsightsAffiliated()">
          <router-link :to="{ path: '/social-media-insights', query: queryObject }">
            Social Media Insights
          </router-link>
        </li>
        <li>
          <a href="https://conta.uol.com.br/logout?dest=http%3A%2F%2Fafiliados.uol.com.br%2Findex.html">
            Sair do painel
          </a>
        </li>
      </ul>
    </div>

    <div v-if="$route.path == '/manutencao'" :class="{ 'menu-right': showNavigation }"
      :style="{ 'padding-top': `0px` }" class="side-menu menu-left" ref="sideMenu">
      <ul>
        <li>
          <a href="https://conta.uol.com.br/logout?dest=http%3A%2F%2Fafiliados.uol.com.br%2Findex.html">
            Sair do painel
          </a>
        </li>
      </ul>
    </div>

    <div v-show="showNavigation" class="overlay" ref="overlay" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      showNavigation: false,
      menuHeight: 0,
      queryString: '',
      queryObject: {},
    };
  },
  computed: {
    ...mapGetters(['affiliateInfo']),
    changeLogoHref() {
      if (this.$route.path === '/manutencao') return '';
      return 'https://www.uol.com.br/?utm_medium=afiliados.uol.com.br&utm_source=afiliados&utm_campaign=barra_uol&utm_content=link_fixo_uol&utm_term=afiliados-uol';
    },
  },
  methods: {
    ...mapActions(['fetchAffiliateData']),
    selectPage(path) {
      return this.$route.path === path ? 'active' : undefined;
    },
    toggleNavigation() {
      this.showNavigation = !this.showNavigation;
      this.menuHeight = this.$refs.menuContainer.getBoundingClientRect().height + 10;
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const head = document.querySelector('head');
        const script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', resolve);
        script.addEventListener('error', reject);
        head.appendChild(script);
      });
    },
    loadStyle(src) {
      return new Promise((resolve, reject) => {
        const head = document.querySelector('head');
        const style = document.createElement('link');
        style.rel = 'stylesheet';
        style.type = 'text/css';
        style.src = src;
        style.addEventListener('load', resolve);
        style.addEventListener('error', reject);
        head.appendChild(style);
      });
    },
    isInsightsAffiliated() {
      return this.affiliateInfo && (this.affiliateInfo.idtPerson === '618775921');
    },
  },
  async created() {
    this.fetchAffiliateData();

    try {
      this.loadStyle('https://conteudo.jsuol.com.br/p/afiliados/uol-header/0.3.3/css/header.min.css');
      this.loadStyle('https://conteudo.jsuol.com.br/p/perfil/css/widgetNotify.v3.css');
      this.loadStyle('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
      await this.loadScript('https://conteudo.jsuol.com.br/p/afiliados/js/3rd/jquery-3.2.0.min.js');
      await this.loadScript('https://conteudo.jsuol.com.br/g/uolfw/1.7.0/js/UOLfw.min.js');
      await this.loadScript('https://conteudo.jsuol.com.br/p/afiliados/uol-header/0.3.3/js/header.min.js');

      const $ = window.jQuery || null;

      if ($) {
        $('body').uolHeader({
          ROIProductId: 120,
          widgetNotifyConfig: {
            widgetStyle: {
              username: 'font-size: 13px; color: white',
            },
            avatarIconColor: 'white',
          },
          homeUrl: 'https://afiliados.uol.com.br',
        });
      }

      this.queryString = window.location.search;
      const queryObject = {};
      this.queryString.substr(1).split('&').forEach((_param) => {
        const param = _param.split('=');
        const key = param.shift();
        const value = param.shift();
        queryObject[key] = value;
      });
      this.queryObject = queryObject;
    } catch (error) {
      console.error('Houve um erro ao inicializar o header', error);
    }
  },
};
</script>
<style lang="scss" scoped>
.container-menu header {
  background-color: $color-1;
  width: 100%;
  -webkit-box-shadow: 0 2px 2px 0 rgba(89, 89, 89, .67);
  -moz-box-shadow: 0 2px 2px 0 rgba(89, 89, 89, .67);
  box-shadow: 0 2px 2px 0 rgba(89, 89, 89, .67);
  z-index: 69;
  font-family: $font-1;
  color: $text-light
}

.disabled {
  pointer-events: none;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul li {
  display: inline-block;
}

.lista-menu-topo li a,
.side-menu li a {
  color: $text-light;
  font-size: 13px;
  padding: 19px 0;
  text-decoration: none;
}

.lista-menu-topo li a:hover,
.side-menu li a:hover {
  color: $text-light;
  text-decoration: none;
}

.container-menu-topo {
  border-bottom: 3px solid rgba(255, 255, 255, 0.15);
}

.container-menu-bottom ul li:first-child:hover {
  border-top: 0;
  background-color: transparent;
}

.container-menu-bottom ul li:hover {
  border-top: 2px solid $text-light;
  display: block;
  background-color: $color-3;
}

.container-menu-bottom ul li {
  padding: 15px 0;
  margin-top: -5px;
}

.container-menu-bottom ul li a {
  font-size: 16px;
  padding: 0 5px;
}

.outline {
  border: 1px solid $text-light;
  color: $text-light;
  padding: 2px 20px;
  position: absolute;
  right: 0;
}

.outline:hover {
  color: $text-light;
}

.content-buttom-out {
  width: 100%;
  position: relative;
  height: 30px;
  font-size: $font-size-smaller;
}

.overlay {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  display: block;
  position: fixed;
}

.navbar-toggle {
  border: 0 !important;
  border-radius: 0 !important;
  padding: 0 0px;
  margin: auto !important;
  background-color: transparent;
}

.icon-bar {
  background-color: $text-light;
  height: 4px;
  display: block;
  width: 22px;
  border-radius: 1px;
  margin-bottom: 4px;
}

.button-mobile {
  display: none;
  cursor: pointer;
  flex-basis: 24px;
  flex-grow: 0;

}

.logo_mobile {
  display: none;
}

.side-menu {
  background-color: $color-1;
  width: 50%;
  z-index: 799;
  position: fixed;
  display: block;
  left: -50%;
  transition: left .3s ease-out;
  height: 100vh;
}

.side-menu ul li a {
  font-size: 16px;
  position: relative;
  display: block;
  padding: 10px 15px;
}

.side-menu ul li {
  transition: all .3s ease-out;
}

.side-menu ul li:hover {
  background-color: $color-3;
}

.side-menu ul li:last-child {
  border-top: 1px solid $text-light;
  border-bottom: 1px solid $text-light;
}

.active {
  border-left: 4px solid $text-light !important;
}

@media screen and (max-width: $lg - 1px) {
  .button-mobile {
    display: block;
  }

  .list_mobile_hidden {
    display: none;
  }

  .logo_mobile {
    display: block;
  }

  .topo {
    position: fixed;
    width: 100%;
    z-index: 800;
    top: 0;
  }

  .overlay {
    top: 0;
    z-index: 797;
  }

  .topo .container {
    width: 100%;
    max-width: 100%;
  }

  .menu-right {
    left: 0;
    transition: left .3s ease-out;
  }

  .side-menu li {
    display: block;
  }

  .side-menu li:hover {
    border-left: 4px solid $text-light;
  }

  .container-menu-topo {
    border-bottom: 0;
    height: 60px;
  }

  .container-menu-topo-inner {
    height: 30px;
  }

  .menu-space {
    display: block;
    height: 60px;
  }

  .content-avatar:hover {
    border-left: none;
  }
}
</style>

<style lang="scss">
@media screen and (max-width: $lg - 1px) {
  .widget-username {
    display: none !important;
  }

  #widgetNotify .widgetUOLAvatarProduct .widget-container {
    width: 24px !important;
    height: 24px !important;
  }
}
</style>
